import React, { useState, useEffect, useRef } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import moment from 'moment';
import API from "../../config/api";
import { ToastContainer, toast } from "react-toastify";
import avatar from "./../../assets/assets_theme/img/avatar/1.jpg";
import CustomModalBlockUser from "../Bar/CustomModalBlockUser";
import CustomModalApproveUser from "../Bar/CustomModalApproveUser";
import CustomModalResetUser from "../Bar/CustomModalResetUser";

const AttandanceEdit = () => {
  const [searchParams] = useSearchParams();
  const [users, setUsers] = useState({
    id: null,
    custom_id: null,
    first_name: '', // Used for "Amount of Days" in render?!
    last_name: '', // Used for "Description" and "Feedback" in render?!
    dob: null,
    email: '',
    address: '',
    gender_id: 0,
    role_id: 4,
    branch_id: 0,
    class_id: 1,
    teacher_id: 4,
    generation: null,
    phone_number: '',
    phone_number2: '',
    profile_url: avatar,
    filename: '',
    file_url: '',
    bio: '',
    test_available: 2,
    block: 0,
    approve: 0,
    active: 1
  });

  const [allBranch, setAllBranch] = useState([]);
  const [dob, setDob] = useState(''); // Used for "From" and "To" in render?!
  const [success, setSuccess] = useState(null);
  const [errors, setErrors] = useState({});

  // Refs
  const inputRefs = {
    first_name: useRef(null),
    last_name: useRef(null),
    dob: useRef(null),
  };

  const limit = 100;
  const page = 1;

  useEffect(() => {
    getAllBranch();

    const id = searchParams.get("id");
    if (id) {
      getOneUser(id);
    }

    const successParam = searchParams.get("success");
    if (successParam) {
      toast.success("Your action is successful", {
        data: {
          title: "Success toast",
          text: "This is a success message",
        },
      })
    }
  }, [searchParams]);

  const getOneUser = async (id) => {
    try {
      let query = `user_id=${id || users.id}`
      let results = await API.getOneUser(query);

      let data = results.data.user;

      setUsers(prev => ({ ...prev, ...data }));
      convertDateToString(data.dob);

    } catch (error) {
      console.log(error)
    }
  }

  const getAllBranch = async () => {
    try {
      let query = `page=${page}&limit=${limit}`
      let results = await API.getAllBranch(query);
      let data = results.data;

      setAllBranch(data.school_branch);

    } catch (error) {
      console.log(error)
    }
  }

  const onProfileChange = async (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    try {
      let results = await API.adminUpload(
        formData,
        (percentage) => { }
      );

      if (results) {
        setUsers(prev => ({
          ...prev,
          profile_url: results.full_url,
          file_url: results.filename
        }));
      }

    } catch (error) {
      console.log(error)
    }
  }

  const convertDate = (dateString) => {
    return moment(dateString, 'YYYYMMDD').format('YYYY-MM-DD');
  };

  const convertDateToString = (date) => {
    if (date) setDob(moment(date).format("YYYYMMDD"));
  };

  const validateFields = () => {
    const newErrors = {};
    let firstEmptyField = null;

    // Based on original code which validated fields state, but we should validate current state values
    // Original validated: first_name, last_name, dob

    if (!users.first_name || !users.first_name.trim()) newErrors.first_name = "First Name is required";
    if (!users.last_name || !users.last_name.trim()) newErrors.last_name = "Last Name is required";
    if (!dob || !String(dob).trim()) newErrors.dob = "Date of Birth is required";

    setErrors(newErrors);

    if (newErrors.first_name && !firstEmptyField) firstEmptyField = 'first_name';
    if (newErrors.last_name && !firstEmptyField) firstEmptyField = 'last_name';
    if (newErrors.dob && !firstEmptyField) firstEmptyField = 'dob';

    if (firstEmptyField && inputRefs[firstEmptyField] && inputRefs[firstEmptyField].current) {
      inputRefs[firstEmptyField].current.focus();
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateFields()) return;

    let data = {
      id: users.id,
      first_name: users.first_name,
      last_name: users.last_name,
      profile_url: users.file_url,
      email: users.email,
      address: users.address,
      gender_id: users.gender_id,
      role_id: users.role_id,
      phone_number: users.phone_number,
      phone_number2: users.phone_number2,
      class_id: users.class_id,
      teacher_id: users.teacher_id,
      dob: convertDate(dob),
      branch_id: users.branch_id,
      generation: users.generation,
      custom_id: users.custom_id,
      bio: users.bio,
      test_available: users.test_available,
    };

    try {
      let results = await API.postUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        setSuccess(results.result);
      }

    } catch (error) {
      console.log(error)
    }
  }

  const blockUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: users.id,
      block: users.block ? 0 : 1,
    }
    try {
      let results = await API.postBlockUser(data);

      if (results.result) {
        getOneUser(users.id);
      }

    } catch (error) {
      console.log(error)
    }
  }

  const approveUser = async (event) => {
    event.preventDefault();
    let data = {
      id: users.id,
      approve: users.approve ? 0 : 1
    }
    try {
      let results = await API.approveUser(data);

      if (results.result) {
        getOneUser(users.id);
      }

    } catch (error) {
      console.log(error)
    }
  }

  const resetUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: users.id
    }
    try {
      let results = await API.resetUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getOneUser(users.id);
      }

    } catch (error) {
      console.log(error)
    }
  }

  const generation = [];
  for (let i = 0; i < 50; i++) {
    generation.push(<option value={i} key={i}> {i + 1}</option>);
  }

  return (
    <div className="col-12">
      <ToastContainer />
      {success && (
        <Navigate to="/userindex?success=true" replace={true} />
      )}
      <form className="card" onSubmit={handleSubmit}>
        <h4 className="card-title fw-400">Attandance </h4>
        <br />

        <div className="card-body">
          <div className="flexbox gap-items-4">
            <img className="avatar avatar-xl" src={users.profile_url ? users.profile_url : avatar} alt="..." />
            <div className="flex-grow">
              <h5>{users.first_name + ' ' + users.last_name}</h5>
              <div className="d-flex flex-column flex-sm-row gap-items-2 gap-y mt-16">
                <div className="file-group file-group-inline">
                  <input type="file" onChange={onProfileChange} />
                </div>
              </div>

            </div>
          </div>

          <hr />

          <div className="row">
            <div className="form-group col-md-6">
              <label className="require" htmlFor="input-required">Amount of Day</label>
              <input type="text" className="form-control" id="input-required" name="days"
                value={users.first_name} // Mapped to first_name as per original!
                ref={inputRefs.first_name}
                style={{
                  border: errors.first_name ? "1px solid red" : "",
                }}
                onChange={(event) => {
                  const val = event.target.value;
                  setUsers(prev => ({ ...prev, first_name: val }));
                  if (errors.first_name) setErrors(prev => ({ ...prev, first_name: "" }));
                }}
              />
              {errors.first_name && <span style={{ color: "red" }}>{errors.first_name}</span>}
            </div>

            <div className="form-group col-md-6">

              <label >Reason</label>
              <select className="form-control" title="&#xA0;" value={users.branch_id}
                onChange={(event) => {
                  const val = event.target.value;
                  setUsers(prev => ({ ...prev, branch_id: val }));
                }}
              >
                <option value={0}> Please select branch </option>
                {
                  allBranch.map((branch, index) => {
                    return <option value={branch.id} key={branch.id}> {branch.name}</option>
                  })
                }
              </select>
            </div>
            <div className="form-group col-md-6">
              <label className="require" htmlFor="input-required">Description</label>
              <input type="text" className="form-control" id="input-required" name="description"
                value={users.last_name} // Mapped to last_name!
                ref={inputRefs.last_name}
                style={{
                  border: errors.last_name ? "1px solid red" : "",
                }}
                onChange={(event) => {
                  const val = event.target.value;
                  setUsers(prev => ({ ...prev, last_name: val }));
                  if (errors.last_name) setErrors(prev => ({ ...prev, last_name: "" }));
                }}
              />
              {errors.last_name && <span style={{ color: "red" }}>{errors.last_name}</span>}

            </div>
            <div className="form-group col-md-6">
              <label className="require" htmlFor="input-required">Feedback</label>
              <input type="text" className="form-control" id="input-required" name="description"
                value={users.last_name} // Also mapped to last_name! Note: this effectively duplicates the input control.
                // ref={inputRefs.last_name} // Removing duplicate ref
                style={{
                  border: errors.last_name ? "1px solid red" : "",
                }}
                onChange={(event) => {
                  const val = event.target.value;
                  setUsers(prev => ({ ...prev, last_name: val }));
                  if (errors.last_name) setErrors(prev => ({ ...prev, last_name: "" }));
                }}
              />
              {errors.last_name && <span style={{ color: "red" }}>{errors.last_name}</span>}

            </div>
            <div className="form-group col-md-6">
              <label className="require" htmlFor="input-required">From</label>
              <input type="date" name="dob"
                className="form-control" id="input-required"
                value={dob}
                ref={inputRefs.dob}
                style={{
                  border: errors.dob ? "1px solid red" : "",
                }}
                onChange={(event) => {
                  const val = event.target.value;
                  setDob(val);
                  if (errors.dob) setErrors(prev => ({ ...prev, dob: "" }));
                }}
              />
              {errors.dob && <span style={{ color: "red" }}>{errors.dob}</span>}

            </div>
            <div className="form-group col-md-6">
              <label className="require" htmlFor="input-required">To</label>
              <input type="date" name="dob"
                className="form-control" id="input-required"
                value={dob} // Mapped to same dob!
                // ref={inputRefs.dob}
                style={{
                  border: errors.dob ? "1px solid red" : "",
                }}
                onChange={(event) => {
                  const val = event.target.value;
                  setDob(val);
                  if (errors.dob) setErrors(prev => ({ ...prev, dob: "" }));
                }}
              />
              {errors.dob && <span style={{ color: "red" }}>{errors.dob}</span>}

            </div>
            <div className="form-group col-md-6">

              <label >Status: &ensp; </label><Link className="btn btn-success" to="#">Approve</Link>
            </div>
          </div>

          <div className="row">
          </div>

        </div>
        <footer className="card-footer text-right">
          <Link className="btn btn-secondary" to={'/userindex'} >Cancel</Link>
          <button className="btn btn-primary" type="submit">Submit</button>
        </footer>

      </form>
      {
        users &&
        <CustomModalBlockUser
          data={users}
          title={users.active ? "Do you really want to unblock this user?" : "Do you really want to block this user?"}
          blockUser={blockUser}
          approveUser={approveUser}
        />
      }
      {
        users &&
        <CustomModalApproveUser
          data={users}
          title={users.approve ? "Do you really want to approve this user?" : "Do you really want to disapprove this user?"}
          approveUser={approveUser}
        />
      }
      {
        users &&
        <CustomModalResetUser
          data={users}
          title="Do you really want to reset this user?"
          approveUser={resetUser}
        />
      }
    </div>
  );
}

export default AttandanceEdit;
